import {
  SET_DATA_INIT_STATE,
  SET_DATA_UN_INIT_STATE,
  DEL_DATA_INIT_STATE,
} from '@/store/actionTypes';

type State = {
  dataInitMap: TypeObject
}

const storeState: State = {
  dataInitMap: {},
};

const mutations = {
  [SET_DATA_INIT_STATE](state: State, key: string): void {
    if (!key) { return; }
    state.dataInitMap[key] = true;
  },
  [SET_DATA_UN_INIT_STATE](state: State, key: string): void {
    if (!key) { return; }
    state.dataInitMap[key] = false;
  },
  [DEL_DATA_INIT_STATE](state: State, key: string): void {
    delete state.dataInitMap[key];
  },
};

export default {
  namespaced: true,
  state: storeState,
  mutations,
};
